import { createSelector } from 'reselect';

import { State } from './types';

const selectState = (state: any): State => state.clinics;

export const selectEditedConditionId = createSelector(
  [selectState],
  (clinics: State) => clinics.conditionEditor.editedConditionId
);
